import { Component } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-section-wrapper',
  imports: [ReactiveFormsModule, FormlyModule],
  templateUrl: './section-wrapper.component.html',
  styleUrl: './section-wrapper.component.scss',
})
export class SectionWrapperComponent extends FieldWrapper {}
